const votings = [
	{
		path: '/community/votings',
		name: 'community-votings-list',
		component: () => import('@/views/community/votings/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/votings/new',
		name: 'community-votings-new',
		component: () => import('@/views/community/votings/wizard.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/votings/:id/edit',
		name: 'community-votings-edit',
		component: () => import('@/views/community/votings/wizard.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
]

export default votings
